/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import createStore from '~common-store/createStore';

import reducers from './slices';

export default createStore({ reducers });
